import { createClient } from "contentful-management";

export const client = createClient(
  {
    accessToken: "CFPAT-VHHYZ8nPcipYKz3V9DK3Sgi0CSgBEvWB_SdKvhIjT4A",
  },
  {
    type: "plain",
    defaults: {
      spaceId: "iizbwse9qod4",
      environmentId: "master",
    },
  }
);
